<template>
    <div class="pt-2 pb-6 md:py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                <SmartBreadcrumbs
                    :pages="[
                        {
                            name: $t('messages.settings'),
                            href: null,
                        },
                    ]"
                />
            </h1>
        </div>
        <div class="max-w-7xl mx-auto md:px-4 sm:px-6 md:px-8">
            <UpdateProfileInformationForm :user="user" :languages="languages" />
            <UpdatePasswordForm />

            <DashboardWidgetSettingsForm :url="sections.widgets.url" :widgets="sections.widgets.widgets" />
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import UpdatePasswordForm from '@/components/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from '@/components/UpdateProfileInformationForm.vue';
import DashboardWidgetSettingsForm from '@/Pages/Teacher/Settings/partials/DashboardWidgetSettingsForm.vue';

export default {
    components: {
        DashboardWidgetSettingsForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },
    layout: Layout,
    name: 'Edit',
    props: ['languages', 'user', 'sections'],
    created() {
        this.$i18n.locale = this.user.preferred_language;
    },
    data() {
        return {
            isLoading: false,
            form: {
                preferred_language: this.user.preferred_language,
                password: null,
                password_confirmation: null,
            },
        };
    },
    methods: {
        submit() {
            this.isLoading = true;
            this.$inertia.patch(this.route('students.settings.update'), this.form, {
                onFinish: () => {
                    this.isLoading = false;
                    this.$i18n.locale = this.user.preferred_language;
                },
            });
        },
    },
};
</script>
